import './legend.css';

const Legend = () => (

    <div className="gantt-legend">
    {/* <span className="legend-title">Legend</span> */}
    <div className="legend-items">
        <div className="legend-item">
            <span className="legend-color ahead"></span>
            <span className="legend-label">Ahead</span>
        </div>
        <div className="legend-item">
            <span className="legend-color delayed"></span>
            <span className="legend-label">Delayed</span>
        </div>
        <div className="legend-item">
            <span className="legend-color on-time"></span>
            <span className="legend-label">On Time</span>
        </div>
        <div className="legend-item">
            <span className="legend-color planned"></span>
            <span className="legend-label">Planned</span>
        </div>
    </div>
</div>
);

export default Legend;